<template>
    <div class="MyBusinessCard">
        <div>
            <div class="followTitle" style="margin-bottom: 17px;">我的二维码名片</div>

            <div v-if="imageUrl !==''" style="margin-bottom: 14px;">
                <img :src="imageUrl" alt="" class="superiorImgPic">
            </div>
            <van-uploader :max-size="2048 * 1024" :max-count="1" :after-read="afterRead" v-if="fileList.length==0"
                @oversize="onOversize" :deletable="false">
                <div class="bottom">
                    <button class="bottomBtn">上传名片</button>
                </div>
            </van-uploader>
            <van-uploader :after-read="afterRead" v-if="fileList.length==1" :deletable="false">
                <div class="bottom">
                    <button class="bottomBtn">上传名片</button>
                </div>
            </van-uploader>
            <div class="tips">图片大小2M以下</div>
        </div>
        <!-- <div v-if="uploadStaus == 2">
            <div class="followTitle">审核状态</div>
            <div class="AuditStatus">
                <img src="../../../assets/images/waiting.png" alt="">
            </div>
            <div class="textStatus">审核中，请耐心等待</div>
            <div class="bottom">
                <button class="bottomBtn">我知道了</button>
            </div>
        </div>
        <div v-if="uploadStaus == 3">
            <div class="followTitle">审核状态</div>
            <div class="AuditStatus">
                <img src="../../../assets/images/underReview.png" alt="">
            </div>
            <div class="textFailStatus">很遗憾，审核未通过</div>
            <div class="failureReason">未通过原因：XXXXXXXXXX</div>
            <div class="bottom">
                <button class="bottomBtn">重新上传</button>
            </div>
            <div class="underReviewTips">图片大小2M以下</div>
        </div> -->
        <van-overlay :show="isLoading">
            <div class="wrapper">
                <loading v-if="isLoading == true"></loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>

import {
    Uploader, Toast, Dialog, Notify, Popup, Overlay
} from "vant";

import loading from "../loading/loading";
import { mapGetters } from "vuex";
import service from "../../api/superior/index";
export default {
    data() {
        return {
            isLoading: true, //loading状态
            // uploadStaus: 3,
            isShow: true,
            imageUrl: '',
            status: false,
            fileList: [],
            pictureList: [],
            userAllMes: {
                pictureUrlList: [],
            },
        };
    },
    components: {
        [Uploader.name]: Uploader,
        [Toast.name]: Toast,
        [Dialog.name]: Dialog,
        [Notify.name]: Notify,
        [Popup.name]: Popup,
        [Overlay.name]: Overlay,
        loading
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    mounted() {
        this.isShow = true
        this.init()
    },
    methods: {
        // 获取二维码名片
        init() {
            this.isLoading = true
            service.getBusinessCard().then(res => {
                if (res.statusCode == 200) {
                    if (res.data == '未提交') {
                        this.fileList = []
                        this.imageUrl = ''
                        setTimeout(() => {
                            this.isLoading = false
                        }, 700);
                    } else {
                        console.log(res.data)
                        this.fileList = []
                        // this.fileList.push(res.data)
                        this.imageUrl = res.data
                        setTimeout(() => {
                            this.isLoading = false
                        }, 700);
                    }

                } else {
                    this.isLoading = false
                    Toast(res.errors);
                    this.imageUrl = ''
                }
            })
        },
        // 关闭
        onClose() {
            this.isShow = false
        },
        afterRead(file) {
            this.isLoading = true
            this.fileList = []
            console.log(file, this.fileList, 'this.status');
            file.status = "uploading";
            file.message = "上传中...";
            this.status = true;
            if (
                file.file.type === "image/jpeg" ||
                file.file.type === "image/jpg" ||
                file.file.type === "image/png"
            ) {
                var formdata = new FormData();
                formdata.append("formfile", file.file);
                service
                    .upload(formdata)
                    .then((res) => {
                        if (res.statusCode == 200) {
                            file.message = "";
                            file.status = "success";
                            this.status = false;
                            file.url = res.data;
                            this.fileList = []
                            this.imageUrl = res.data
                            setTimeout(() => {
                                this.isLoading = false
                            }, 700);
                            // this.fileList.push(file)
                            // this.pictureList.push(file);
                        } else {
                            this.isLoading = false
                            this.fileList = []
                            // this.fileList.push(file)
                            Toast(res.errors);
                            file.status = "failed";
                            file.message = "上传失败";
                            // this.status = true;
                            return;
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false
                        this.fileList = []
                        // this.fileList.push(file)
                        file.status = "failed";
                        file.message = "上传失败";
                        // this.status = true;
                        Toast(error);
                        // Toast("上传失败,请稍后重试");
                    });
            } else {
                this.isLoading = false
                file.status = "failed";
                this.status = true;
                file.message = "上传失败";
                Toast("请上传 jpg或png 格式图片");
                console.log(this.status, "图片格式false");
                return;
            }
        },
        onOversize(file) {
            Toast("文件大小不得大于2MB.");
        },
    },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.MyBusinessCard {
    width: 263px;
    max-height: 477px;
    padding: 16px;

    .followTitle {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
        width: 100%;
        text-align: center;
        // margin-left: 12px;
        // padding-bottom: 14px;
    }

    // 提示
    .tips {
        text-align: center;
        margin-top: 16px;
        color: #999999;
        font-size: 12px;
    }

    .underReviewTips {
        text-align: center;
        margin-top: 16px;
        color: #999999;
        font-size: 12px;
    }

    .textStatus {
        height: 21px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
        text-align: center;
        margin-bottom: 18px;
    }

    .AuditStatus {
        width: 80px;
        margin: 23px auto 15px;
    }

    .textFailStatus {
        height: 21px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
        text-align: center;

    }

    .failureReason {
        font-size: 12px;
        font-weight: 400;
        color: #F00724;
        line-height: 12px;
        text-align: center;
        margin-bottom: 14px;
        margin-top: 10px;
    }

    // 按钮样式
    .bottom {
        margin: auto;

        .bottomBtn {
            width: 100%;
            height: 40px;
            background: #ee0a24;
            border: 0;
            border-radius: 4px;
            color: #fff;
            font-size: 14px;
        }
    }

    // 上传名片样式
    .van-uploader {
        width: 100%;
    }

    @{deep}.van-uploader__input-wrapper {
        width: 100%;
    }

    @{deep}.van-uploader__preview {
        width: 100%;
        margin: 0 0 16px 0;
    }

    @{deep}.van-uploader__file {
        margin: auto;
    }

    @{deep}.van-uploader__preview-image {
        display: block;
        width: 100%;
        height: 100%;
        max-width: 263px;
        max-height: 350px;
        margin: auto;
    }
}
</style>
  